interface Props {
  [name: string]: {
    dataStartArr: number[];
    pageBreakArr: number[];
    pageBreakSbmArr?: number[];
    // template_id는 측정값 id, 배열의 숫자 [row, col]
    // row는 dataStartArr에서 엑셀의 측정값 입력 부분 row 뺀 값
    // 나중에 dataStartArr만 바뀌어도 자동으로 바뀌게 하기 위해서 그렇게 함
    calculateInfoArr?: {
      [template_id: number]: number[];
    }[];
    dataInspectionArr?: number[];
    dataSbmStartArr?: number[];
  };
}

// 24.03.26 엑셀 사진 6개 부분
export const rowStartNumTemplateImg6: Props = {
  냉각탑: {
    dataStartArr: [49, 79, 107, 134, 160, 195, 220, 249, 280, 305],
    dataInspectionArr: [42, 68,  98, 126, 153, 179, 214, 243, 272, 299],
    pageBreakArr: [40, 66, 96, 124, 151, 177, 212, 241, 270, 297],
    pageBreakSbmArr: [41, 67, 97, 125, 152, 178, 213, 242, 271, 298],
    calculateInfoArr: [
      {
        0: [20, 1],
        3: [20, 4],
        4: [20, 7],
        5: [20, 10],
      },
      {
        0: [20, 1],
        6: [20, 4],
        7: [20, 7],
        8: [20, 10],
      },
      {
        0: [20, 1],
        9: [20, 4],
        10: [20, 7],
        11: [20, 10],
      },
    ],
  },
  냉동기: {
    dataStartArr: [
      53, 78, 103, 128, 153, 196, 220, 257, 282, 307, 332, 359, 386, 413, 451,
    ],
    dataInspectionArr: [
      46, 73, 97, 122, 147, 172, 215, 239, 276, 301, 326, 351, 378, 405, 432
    ],
    pageBreakArr: [
      44, 70, 95, 120, 145, 170, 213, 237, 274, 299, 324, 349, 376, 403, 430,
    ],
    pageBreakSbmArr: [
      45, 71, 96, 121, 146, 171, 214, 238, 275, 300, 325, 350, 377, 404, 431,
    ],
    calculateInfoArr: [
      {
        0: [20, 1],
        1: [20, 5],
        2: [20, 9],
      },
    ],
  },
  '냉온수기(난방성능)': {
    dataStartArr: [45, 88, 112, 137, 164, 191, 218],
    dataInspectionArr: [38, 64, 107, 131, 156, 183, 210],
    pageBreakArr: [37, 63, 106, 130, 155, 182, 209],
    pageBreakSbmArr: [37, 63, 106, 130, 155, 182, 209],
  },
  축열조: {
    dataStartArr: [45, 70, 98, 123, 148, 176, 203],
    dataInspectionArr: [38, 64, 89, 117, 142, 171, 195],
    pageBreakArr: [36, 62, 87, 115, 140, 169, 193],
    pageBreakSbmArr: [37, 63, 88, 116, 141, 170, 194],
    calculateInfoArr: [
      {
        0: [20, 1],
        12: [20, 5],
        13: [20, 9],
      },
    ],
  },
  보일러: {
    dataStartArr: [49, 77, 104, 136, 163, 189, 218, 261, 289, 316, 343],
    dataInspectionArr: [42, 68, 96, 123, 155, 182, 208, 237, 280, 308, 335],
    pageBreakArr: [40, 66, 94, 121, 153, 180, 206, 235, 278, 306, 333],
    pageBreakSbmArr: [41, 67, 95, 122, 154, 181, 207, 236, 279, 307, 334],
  },
  '캐스케이드 보일러': {
    dataStartArr: [47, 75, 102, 129, 155, 183, 226, 254, 281],
    dataInspectionArr: [40, 66, 94, 121, 148, 174, 202, 245, 273],
    pageBreakArr: [39, 65, 93, 120, 147, 173, 201, 244, 272],
    pageBreakSbmArr: [39, 65, 93, 120, 147, 173, 201, 244, 272],
  },
  열교환기: {
    dataStartArr: [44, 72, 103, 134, 159, 185],
    dataInspectionArr: [37, 63, 91, 128, 153, 178],
    pageBreakArr: [35, 61, 89, 126, 151, 176],
    pageBreakSbmArr: [36, 62, 90, 127, 152, 177],
    calculateInfoArr: [
      {
        14: [20, 4],
        15: [20, 7],
        16: [20, 10],
        17: [22, 4],
        18: [22, 7],
        19: [22, 10],
      },
    ],
  },
  팽창탱크: {
    dataStartArr: [42, 67, 92, 125],
    dataInspectionArr: [35, 61, 86, 115],
    pageBreakArr: [33, 59, 84, 113],
    pageBreakSbmArr: [34, 60, 85, 114],
    calculateInfoArr: [
      {
        0: [20, 1],
        20: [20, 5],
        21: [20, 9],
      },
    ],
  },
  '펌프(냉·난방)': {
    dataStartArr: [46, 72, 115, 148, 174, 200, 231],
    dataInspectionArr: [39, 65, 91, 134, 167, 193, 223],
    pageBreakArr: [37, 63, 89, 132, 165, 191, 221],
    pageBreakSbmArr: [38, 64, 90, 133, 166, 192, 222],
    calculateInfoArr: [
      {
        0: [20, 1],
        22: [20, 5],
        23: [20, 9],
      },
      {
        24: [20, 4],
        25: [20, 7],
        26: [20, 10],
        27: [22, 4],
        28: [22, 7],
        29: [22, 10],
        30: [24, 4],
        31: [24, 7],
        32: [24, 10],
      },
    ],
  },
  '신재생(지열)': {
    dataStartArr: [40, 68, 94],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(태양열)': {
    dataStartArr: [40, 68, 93],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(연료전지)': {
    dataStartArr: [40, 68, 93],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '신재생(대기열)': {
    dataStartArr: [40, 68, 94],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  '패키지 에어컨': {
    dataStartArr: [44, 69, 95, 120, 145],
    dataInspectionArr: [37, 63, 88, 114, 139],
    pageBreakArr: [35, 61, 86, 112, 137],
    pageBreakSbmArr: [36, 62, 87, 113, 138],
  },
  항온항습기: {
    dataStartArr: [43, 68, 93, 118, 143],
    dataInspectionArr: [36, 62, 87, 112, 137],
    pageBreakArr: [34, 60, 85, 110, 135],
    pageBreakSbmArr: [35, 61, 86, 111, 136],
  },
  공기조화기: {
    dataStartArr: [46, 72, 98, 123, 148, 191, 216, 242],
    dataInspectionArr: [39, 65, 91, 117, 142, 183, 210, 235],
    pageBreakArr: [37, 63, 89, 115, 140, 181, 208, 233],
    pageBreakSbmArr: [38, 64, 90, 116, 141, 182, 209, 234],
    calculateInfoArr: [
      {
        33: [20, 4],
        34: [20, 7],
        35: [20, 10],
        36: [22, 4],
        37: [22, 7],
        38: [22, 10],
        39: [24, 4],
        40: [24, 7],
        41: [24, 10],
        42: [28, 4],
        43: [28, 7],
        44: [28, 10],
        45: [30, 4],
        46: [30, 7],
        47: [30, 10],
        48: [32, 4],
        49: [32, 7],
        50: [32, 10],
      },
      {
        0: [20, 1],
        51: [20, 5],
        52: [20, 9],
      },
    ],
  },
  팬코일유닛: {
    dataStartArr: [45, 73, 98, 123, 148, 174],
    dataInspectionArr: [38, 64, 92, 117, 142, 167],
    pageBreakArr: [36, 62, 90, 115, 140, 165],
    pageBreakSbmArr: [37, 63, 91, 116, 141, 166],
  },
  환기설비: {
    dataStartArr: [46, 75, 100, 126, 152, 178, 211],
    dataInspectionArr: [39, 65, 94, 119, 145, 171, 205],
    pageBreakArr: [37, 63, 92, 117, 143, 169, 203],
    pageBreakSbmArr: [38, 64, 93, 118, 144, 170, 204],
    calculateInfoArr: [
      {
        53: [20, 4],
        54: [20, 7],
        55: [20, 10],
        56: [22, 4],
        57: [22, 7],
        58: [22, 10],
        59: [24, 4],
        60: [24, 7],
        61: [24, 10],
      },
    ],
  },
  필터: {
    dataStartArr: [41, 66, 96],
    dataInspectionArr: [34, 60, 89],
    pageBreakArr: [32, 58, 87],
    pageBreakSbmArr: [33, 59, 88],
    calculateInfoArr: [
      {
        0: [20, 1],
        62: [20, 5],
        63: [20, 9],
      },
    ],
  },
  위생기구설비: {
    dataStartArr: [41, 69, 100, 125],
    dataInspectionArr: [34, 60, 94, 119],
    pageBreakArr: [32, 58, 92, 117],
    pageBreakSbmArr: [33, 59, 93, 118],
    calculateInfoArr: [
      {
        64: [20, 5],
        65: [20, 9],
        66: [22, 5],
        67: [22, 9],
      },
    ],
  },
  '급수·급탕설비': {
    dataStartArr: [41, 68, 93, 119],
    dataInspectionArr: [34, 60, 87, 112],
    pageBreakArr: [32, 58, 85, 110],
    pageBreakSbmArr: [33, 59, 86, 111],
  },
  '고·저수조': {
    dataStartArr: [41, 67, 93, 130],
    dataInspectionArr: [34, 60, 86, 112],
    pageBreakArr: [32, 58, 84, 110],
    pageBreakSbmArr: [33, 59, 85, 111],
  },
  '오·배수 통기 및 우수배수설비': {
    dataStartArr: [42, 70, 95, 121, 146],
    dataInspectionArr: [35, 61, 89, 114, 140],
    pageBreakArr: [33, 59, 87, 112, 138],
    pageBreakSbmArr: [34, 60, 88, 113, 139],
  },
  오수정화설비: {
    dataStartArr: [41, 68, 93, 118],
    dataInspectionArr: [34, 60, 87, 112],
    pageBreakArr: [32, 58, 85, 110],
    pageBreakSbmArr: [33, 59, 86, 111],
  },
  '물 재이용설비': {
    dataStartArr: [43, 68, 93, 119, 144, 168],
    dataInspectionArr: [36, 62, 87, 112, 138, 163],
    pageBreakArr: [34, 60, 85, 110, 136, 161],
    pageBreakSbmArr: [35, 61, 86, 111, 137, 162],
  },
  배관설비: {
    dataStartArr: [41, 67, 110, 136],
    dataInspectionArr: [34, 60, 86, 129],
    pageBreakArr: [32, 58, 84, 127],
    pageBreakSbmArr: [33, 59, 85, 128],
  },
  덕트설비: {
    dataStartArr: [40, 68, 96],
    dataInspectionArr: [33, 59, 87],
    pageBreakArr: [31, 57, 85],
    pageBreakSbmArr: [32, 58, 86],
  },
  보온설비: {
    dataStartArr: [42, 67, 92, 118, 146],
    dataInspectionArr: [35, 61, 86, 111, 137],
    pageBreakArr: [33, 59, 84, 109, 135],
    pageBreakSbmArr: [34, 60, 85, 110, 136],
  },
  자동제어설비: {
    dataStartArr: [45, 70, 95, 120, 146, 172, 198],
    dataInspectionArr: [38, 64, 89, 114, 139, 165, 191],
    pageBreakArr: [36, 62, 87, 112, 137, 163, 189],
    pageBreakSbmArr: [37, 63, 88, 113, 138, 164, 190],
  },
  '방음·방진·내진설비': {
    dataStartArr: [40, 70, 98],
    dataInspectionArr: [33, 59, 89],
    pageBreakArr: [31, 57, 87],
    pageBreakSbmArr: [32, 58, 88],
  },
};

// 24.03.26 엑셀 사진 3개 부분
export const rowStartNumTemplateImg3: Props = {
  냉각탑: {
    dataStartArr: [49, 71, 91, 110, 128, 155, 172, 193, 216, 233],
    dataInspectionArr: [42, 60, 82, 102, 121, 139, 166, 187, 208, 227],
    pageBreakArr: [40, 80, 119, 137, 164, 206],
    pageBreakSbmArr: [41, 81, 120, 138, 165, 207],
    calculateInfoArr: [
      {
        0: [12, 1],
        3: [12, 4],
        4: [12, 7],
        5: [12, 10],
      },
      {
        0: [12, 1],
        6: [12, 4],
        7: [12, 7],
        8: [12, 10],
      },
      {
        0: [12, 1],
        9: [12, 4],
        10: [12, 7],
        11: [12, 10],
      },
    ],
  },
  냉동기: {
    dataStartArr: [
      53, 70, 87, 104, 121, 162, 178, 207, 224, 241, 258, 277, 296, 315, 351,
    ],
    dataSbmStartArr: [
      53, 70, 87, 104, 121, 158, 174, 200, 217, 234, 251, 270, 289, 308, 344,
    ],
    dataInspectionArr: [
      46, 64, 81, 98, 115, 132, 169, 185, 211, 228, 245, 262, 281, 300, 319
    ],
    pageBreakArr: [44, 79, 113, 130, 171, 187, 216, 250, 286, 324],
    pageBreakSbmArr: [45, 80, 114, 131, 168, 184, 210, 244, 280, 318],
    calculateInfoArr: [
      {
        0: [12, 1],
        1: [12, 5],
        2: [12, 9],
      },
    ],
  },
  '냉온수기(난방성능)': {
    dataStartArr: [45, 82, 98, 115, 134, 153, 172],
    dataInspectionArr: [38, 56, 93, 109, 126, 145, 164],
    pageBreakArr: [37, 55, 92, 108, 144],
    pageBreakSbmArr: [37, 55, 92, 108, 144],
  },
  축열조: {
    dataStartArr: [45, 62, 82, 99, 116, 136, 155],
    dataInspectionArr: [38, 56, 73, 93, 110, 131, 147],
    pageBreakArr: [36, 71, 108, 145],
    pageBreakSbmArr: [37, 72, 109, 146],
    calculateInfoArr: [
      {
        0: [12, 1],
        12: [12, 5],
        13: [12, 9],
      },
    ],
  },

  보일러: {
    dataStartArr: [49, 69, 88, 112, 131, 149, 170, 208, 228, 247, 266],
    dataInspectionArr: [42, 60, 80, 99, 123, 142, 160, 181, 219, 239, 258],
    pageBreakArr: [40, 78, 121, 158, 179, 217, 256],
    pageBreakSbmArr: [41, 79, 122, 159, 180, 218, 257],
  },
  '캐스케이드 보일러': {
    dataStartArr: [47, 67, 86, 105, 123, 143, 181, 201, 220],
    dataInspectionArr: [40, 58, 78, 97, 116, 134, 154, 192, 212],
    pageBreakArr: [39, 77, 115, 153, 191],
    pageBreakSbmArr: [39, 77, 115, 153, 191],
  },
  열교환기: {
    dataStartArr: [44, 64, 87, 110, 127, 145],
    dataInspectionArr: [37, 55, 75, 104, 121, 138],
    pageBreakArr: [35, 73, 102, 136],
    pageBreakSbmArr: [36, 74, 103, 137],
    calculateInfoArr: [
      {
        14: [12, 4],
        15: [12, 7],
        16: [12, 10],
        17: [14, 4],
        18: [14, 7],
        19: [14, 10],
      },
    ],
  },
  팽창탱크: {
    dataStartArr: [42, 59, 76, 101],
    dataInspectionArr: [35, 53, 70, 91],
    pageBreakArr: [33, 68],
    pageBreakSbmArr: [34, 69],
    calculateInfoArr: [
      {
        0: [12, 1],
        20: [12, 5],
        21: [12, 9],
      },
    ],
  },
  '펌프(냉·난방)': {
    dataStartArr: [46, 64, 107, 132, 150, 168, 191],
    dataSbmStartArr: [46, 64, 104, 128, 146, 164, 187],
    dataInspectionArr: [39, 57, 75, 115, 139, 157, 179],
    pageBreakArr: [37, 73, 116, 159, 181],
    pageBreakSbmArr: [38, 74, 114, 156, 178],
    calculateInfoArr: [
      {
        0: [12, 1],
        22: [12, 5],
        23: [12, 9],
      },
      {
        24: [12, 4],
        25: [12, 7],
        26: [12, 10],
        27: [14, 4],
        28: [14, 7],
        29: [14, 10],
        30: [16, 4],
        31: [16, 7],
        32: [16, 10],
      },
    ],
  },
  '신재생(지열)': {
    dataStartArr: [40, 60, 78],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(태양열)': {
    dataStartArr: [40, 60, 77],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(연료전지)': {
    dataStartArr: [40, 60, 77],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '신재생(대기열)': {
    dataStartArr: [40, 60, 78],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  '패키지 에어컨': {
    dataStartArr: [44, 61, 79, 96, 113],
    dataInspectionArr: [37, 55, 72, 90, 107],
    pageBreakArr: [35, 70, 105],
    pageBreakSbmArr: [36, 71, 106],
  },
  항온항습기: {
    dataStartArr: [43, 60, 77, 94, 111],
    dataInspectionArr: [36, 54, 71, 88, 105],
    pageBreakArr: [34, 69, 103],
    pageBreakSbmArr: [35, 70, 104],
  },
  공기조화기: {
    dataStartArr: [46, 64, 82, 99, 116, 151, 168, 186],
    dataInspectionArr: [39, 57, 75, 93, 110, 143, 162, 179],
    pageBreakArr: [37, 73, 108, 141, 177],
    pageBreakSbmArr: [38, 74, 109, 142, 178],
    calculateInfoArr: [
      {
        33: [12, 4],
        34: [12, 7],
        35: [12, 10],
        36: [14, 4],
        37: [14, 7],
        38: [14, 10],
        39: [16, 4],
        40: [16, 7],
        41: [16, 10],
        42: [20, 4],
        43: [20, 7],
        44: [20, 10],
        45: [22, 4],
        46: [22, 7],
        47: [22, 10],
        48: [24, 4],
        49: [24, 7],
        50: [24, 10],
      },
      {
        0: [12, 1],
        51: [12, 5],
        52: [12, 9],
      },
    ],
  },
  팬코일유닛: {
    dataStartArr: [45, 65, 82, 99, 116, 134],
    dataInspectionArr: [38, 56, 76, 93, 110, 127],
    pageBreakArr: [36, 74, 108],
    pageBreakSbmArr: [37, 75, 109],
  },
  환기설비: {
    dataStartArr: [46, 67, 84, 102, 120, 138, 163],
    dataInspectionArr: [39, 57, 78, 95, 113, 131, 157],
    pageBreakArr: [37, 76, 111, 129, 155],
    pageBreakSbmArr: [38, 77, 112, 130, 156],
    calculateInfoArr: [
      {
        53: [12, 4],
        54: [12, 7],
        55: [12, 10],
        56: [14, 4],
        57: [14, 7],
        58: [14, 10],
        59: [16, 4],
        60: [16, 7],
        61: [16, 10],
      },
    ],
  },
  필터: {
    dataStartArr: [41, 58, 80],
    dataInspectionArr: [34, 52, 73],
    pageBreakArr: [32, 71],
    pageBreakSbmArr: [33, 72],
    calculateInfoArr: [
      {
        0: [12, 1],
        62: [12, 5],
        63: [12, 9],
      },
    ],
  },
  위생기구설비: {
    dataStartArr: [41, 61, 84, 101],
    dataInspectionArr: [34, 52, 78, 95],
    pageBreakArr: [32, 50, 76],
    pageBreakSbmArr: [33, 51, 77],
    calculateInfoArr: [
      {
        64: [12, 5],
        65: [12, 9],
        66: [14, 5],
        67: [14, 9],
      },
    ],
  },
  '급수·급탕설비': {
    dataStartArr: [41, 60, 77, 95],
    dataInspectionArr: [34, 52, 71, 88],
    pageBreakArr: [32, 69],
    pageBreakSbmArr: [33, 70],
  },
  '고·저수조': {
    dataStartArr: [41, 59, 77, 106],
    dataInspectionArr: [34, 52, 70, 88],
    pageBreakArr: [32, 68, 86],
    pageBreakSbmArr: [33, 69, 87],
  },
  '오·배수 통기 및 우수배수설비': {
    dataStartArr: [42, 62, 79, 97, 114],
    dataInspectionArr: [35, 53, 73, 90, 108],
    pageBreakArr: [33, 71, 106],
    pageBreakSbmArr: [34, 72, 107],
  },
  오수정화설비: {
    dataStartArr: [41, 60, 77, 94],
    dataInspectionArr: [34, 52, 71, 88],
    pageBreakArr: [32, 69],
    pageBreakSbmArr: [33, 70],
  },
  '물 재이용설비': {
    dataStartArr: [43, 60, 77, 95, 112, 128],
    dataInspectionArr: [36, 54, 71, 88, 106, 123],
    pageBreakArr: [34, 69, 104],
    pageBreakSbmArr: [35, 70, 105],
  },
  배관설비: {
    dataStartArr: [41, 59, 101, 119],
    dataInspectionArr: [34, 52, 70, 112],
    pageBreakArr: [32, 68, 110],
    pageBreakSbmArr: [33, 69, 111],
  },
  덕트설비: {
    dataStartArr: [40, 60, 80],
    dataInspectionArr: [33, 51, 71],
    pageBreakArr: [31, 69],
    pageBreakSbmArr: [32, 70],
  },
  보온설비: {
    dataStartArr: [42, 59, 76, 94, 114],
    dataInspectionArr: [35, 53, 70, 87, 105],
    pageBreakArr: [33, 68, 103],
    pageBreakSbmArr: [34, 69, 104],
  },
  자동제어설비: {
    dataStartArr: [45, 62, 79, 96, 114, 132, 150],
    dataInspectionArr: [38, 56, 73, 90, 107, 125, 143],
    pageBreakArr: [36, 71, 105, 141],
    pageBreakSbmArr: [37, 72, 106, 142],
  },
  '방음·방진·내진설비': {
    dataStartArr: [40, 62, 82],
    dataInspectionArr: [33, 51, 73],
    pageBreakArr: [31, 71],
    pageBreakSbmArr: [32, 72],
  }
};
